import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(localStorage.getItem("accessToken") ? { accessToken: localStorage.getItem("accessToken") } : {});
    const [persist, setPersist] = useState(JSON.parse(localStorage.getItem("persist") !== "undefined" ? localStorage.getItem("persist") : true) || true);

    return (
        <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
